export function formatDateTime(iso: string): string {
  return new Date(iso).toLocaleString("en-US", {
    timeZone: "America/Los_Angeles",
    month: "short",
    day: "numeric",
    hour: "numeric",
    minute: "2-digit",
  });
}

export function statusBadgeVariant(status: string): "secondary" | "default" | "outline" {
  if (status === "unfulfilled") return "outline";
  return "default";
}
